module.exports = __webpack_public_path__ + "img/TeamManagement.3759afeb.svg";